import {
  MAX_LENGTH_MESSAGE,
  REQUIRED_MESSAGE,
  requiredString,
} from '@wyz/utils';
import { z } from 'zod';
import { COMPUTED_PRICING_POLICY_STATUS } from '~/common/schemas';
import {
  PP_CUSTOM_CONSTRAINT,
  PRICING_POLICY_STATUS,
} from '~/purchase/schemas';

export const redistributionServicePricingForm = z.object({
  name: requiredString.max(
    PP_CUSTOM_CONSTRAINT.NAME_MAX_LENGTH,
    MAX_LENGTH_MESSAGE,
  ),
  startDate: z.date({
    error: (issue) =>
      issue.input === undefined ? REQUIRED_MESSAGE : undefined,
  }),
  endDate: z.date().nullish(),
  defaultValue: z.record(z.string(), z.object({ value: z.number().nullish() })),
  oneTyreDelivery: z.object({
    supplierTypes: z.record(
      z.string(),
      z.object({
        tyreTypes: z.record(
          z.string(),
          z.object({ value: z.number().nullish() }),
        ),
      }),
    ),
  }),
});

export const redistributionServicePricingPolicySchema = z.object({
  id: z.string(),
  name: z.string(),
  createdBy: z.string(),
  updatedBy: z.string().nullable(),
  updatedAt: z.date().nullable(),
  startDate: z.date(),
  endDate: z.date().nullable(),
  status: z.enum(PRICING_POLICY_STATUS),
  computedStatus: z.enum(COMPUTED_PRICING_POLICY_STATUS),
  formattedStartDate: z.string(),
  formattedEndDate: z.string().nullable(),
  createdAt: z.date().nullable(),
  policyGroupId: z.number(),
});
